import { render } from "./plans.vue?vue&type=template&id=d42dc6ca&scoped=true"
const script = {}

import "./plans.vue?vue&type=style&index=0&id=d42dc6ca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d42dc6ca"

export default script